import React from 'react';

import { COLOR } from '@/theme/colors';
import { SVGIconProps } from '@/types/svg';

const GiftIcon: React.FC<SVGIconProps> = ({
    width = 20,
    height = 20,
    color = COLOR.deepCerulean,
}) => {
    return (
        <svg
            id="giftbox_324687"
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 18.399 18.367"
            fill={color}
        >
            <g
                id="Group_2426"
                data-name="Group 2426"
                transform="translate(0 0)"
            >
                <g
                    id="Group_2425"
                    data-name="Group 2425"
                    transform="translate(0 0)"
                >
                    <path
                        id="Path_1060"
                        data-name="Path 1060"
                        d="M17.2,4.016H15.86a2.131,2.131,0,0,0,.326-.925A2.382,2.382,0,0,0,12.219,1.07L10.528,2.6a1.8,1.8,0,0,0-2.658,0L6.176,1.069A2.382,2.382,0,0,0,2.209,3.091a2.131,2.131,0,0,0,.326.925H1.2A1.2,1.2,0,0,0,0,5.215v1.8a.6.6,0,0,0,.6.6H17.8a.6.6,0,0,0,.6-.6v-1.8A1.2,1.2,0,0,0,17.2,4.016Zm-9.8-.2v.2H4.577a1.181,1.181,0,0,1-.5-2.253,1.155,1.155,0,0,1,1.292.2L7.4,3.8C7.4,3.8,7.4,3.81,7.4,3.816ZM15,2.931a1.215,1.215,0,0,1-1.233,1.085H11v-.2c0-.007,0-.014,0-.021l2-1.811a1.2,1.2,0,0,1,1.135-.29A1.167,1.167,0,0,1,15,2.931Z"
                        transform="translate(0 -0.448)"
                    />
                </g>
            </g>
            <g
                id="Group_2428"
                data-name="Group 2428"
                transform="translate(1.2 8.367)"
            >
                <g id="Group_2427" data-name="Group 2427">
                    <path
                        id="Path_1061"
                        data-name="Path 1061"
                        d="M33.391,233.291v8.8a1.2,1.2,0,0,0,1.2,1.2h5.6v-10Z"
                        transform="translate(-33.391 -233.291)"
                    />
                </g>
            </g>
            <g
                id="Group_2430"
                data-name="Group 2430"
                transform="translate(10.399 8.367)"
            >
                <g id="Group_2429" data-name="Group 2429">
                    <path
                        id="Path_1062"
                        data-name="Path 1062"
                        d="M289.391,233.291v10h5.6a1.2,1.2,0,0,0,1.2-1.2v-8.8Z"
                        transform="translate(-289.391 -233.291)"
                    />
                </g>
            </g>
        </svg>
    );
};

export default GiftIcon;
